import cn from 'classnames'
import React, { memo } from 'react'

import styles from './Hint.module.scss'

import HintIcon from '~shared/icons/16/hint.svg'
import Tooltip, { TooltipProps } from '~shared/ui/Tooltip'

type HintTooltipProps = Pick<
  TooltipProps,
  'content' | 'placement' | 'portalRoot' | 'offset' | 'shift' | 'delay' | 'maxWidth' | 'minWidth' | 'width' | 'disabled'
>

export interface HintProps extends Prefer<HintTooltipProps, React.HTMLAttributes<HTMLElement>> {
  as?: React.ElementType
  className?: string
  tooltipClassName?: string
}

function Hint({
  as: Component = 'span',
  content,
  className,
  placement = 'top',
  portalRoot,
  offset,
  shift,
  delay,
  minWidth,
  maxWidth,
  width,
  disabled,
  tooltipClassName,
  ...props
}: HintProps) {
  return (
    <Tooltip
      className={tooltipClassName}
      trigger="hover"
      content={content}
      placement={placement}
      portalRoot={portalRoot}
      offset={offset}
      shift={shift}
      delay={delay}
      minWidth={minWidth}
      maxWidth={maxWidth}
      width={width}
      interactive
      disabled={disabled}
    >
      <Component className={cn(styles.root, className)} aria-disabled={disabled} {...props}>
        <HintIcon />
      </Component>
    </Tooltip>
  )
}

export default memo(Hint)
